import { __require as requirePolyfill } from './polyfill.js';
import { __require as requireDefineProperties } from '../define-properties/index.js';

var shim;
var hasRequiredShim;

function requireShim () {
	if (hasRequiredShim) return shim;
	hasRequiredShim = 1;

	var getPolyfill = requirePolyfill();
	var define = requireDefineProperties();

	shim = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};
	return shim;
}

export { requireShim as __require };
